import React, { useEffect, useState } from "react";
import "./style.scss";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import { message } from "antd";
import LocationSelector from "../../../common/LocationSelector";
import Button from "../../../common/Button";
import {
  useGetBillingInformation,
  useInitiateCheckoutForBatch,
  useUpdateBillingInformation,
} from "../../../hooks/useOrderBatches";
const BillingDetails = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({});
  const [formInputs, setFormInputs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const params = useParams();
  const location = useLocation();
  useEffect(() => {
    const formInput = [
      {
        id: 1,
        className: "semi_form_group",
        placeholder: "Enter First Name",
        label: "First Name",
        name: "firstName",
        value: formData.firstName || "",
        type: "text",
        required: true,
      },
      {
        id: 2,
        className: "semi_form_group",
        placeholder: "Enter Last Name",
        label: "Last Name",
        name: "lastName",
        value: formData.lastName || "",
        type: "text",
        required: true,
      },
      {
        id: 3,
        className: "semi_form_group",
        placeholder: "Enter Email Address",
        label: "Email Address",
        name: "email",
        value: formData.email || "",
        type: "email",
        required: true,
      },
      {
        id: 4,
        className: "semi_form_group",
        placeholder: "Enter Company Name",
        label: "Company Name",
        name: "companyName",
        value: formData.companyName || "",
        type: "text",
        required: true,
      },
      {
        id: 5,
        className: "form_group",
        placeholder: "Address Line 1",
        label: "Address Line 1",
        name: "addressLine1",
        value: formData.addressLine1 || "",
        required: true,
      },
      {
        id: 6,
        className: "form_group",
        placeholder: "Address Line 2",
        label: "Address Line 2",
        name: "addressLine2",
        value: formData.addressLine2 || "",
        required: false,
      },

      {
        id: 7,
        className: "semi_form_group",
        placeholder: "Zip / Postal Code",
        label: "Zip / Postal Code",
        name: "zipCode",
        value: formData.zipCode || "",
        required: true,
      },
      {
        id: 8,
        className: "semi_form_group",
        placeholder: "EU VAT Number",
        label: "EU VAT Number (Optional)",
        name: "taxInfo",
        value: formData.taxInfo || "",
        required: false,
      },
    ];
    setFormInputs(formInput);
  }, [formData]);

  const onSuccessUpdate = () => {
    message.success("Billing Information updated successfully");
    checkoutPayment();
  };

  const onErrorUpdate = (res) => {
    console.log(res);
  };

  const { mutate: updateBilling } = useUpdateBillingInformation(
    onSuccessUpdate,
    onErrorUpdate
  );

  const onSuccessGetBilling = (res) => {
    if (res.status === 200 && res?.data?.billingAddress) {
      const { contactPerson, ...billingData } = res?.data?.billingAddress;
      const nameParts = contactPerson.name.split(" ");
      setFormData({
        firstName: nameParts[0],
        lastName: nameParts.slice(1).join(" "),
        email: contactPerson.email,
        companyName: contactPerson.companyName,
        ...billingData,
      });
    }
  };

  const onErrorGetBilling = (err) => {
    console.log(err);
  };

  const { refetch: getBillingInfo } = useGetBillingInformation(
    onSuccessGetBilling,
    onErrorGetBilling
  );

  useEffect(() => {
    getBillingInfo();
  }, [getBillingInfo]);

  const updateBillingInformation = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const payload = {
      contactPerson: {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        companyName: formData.companyName,
      },
      country: formData?.country,
      zipCode: formData.zipCode,
      city: formData?.city,
      stateOrProvince: formData.stateOrProvince,
      addressLine1: formData.addressLine1,
      addressLine2: formData.addressLine2,
      taxInfo: formData.taxInfo,
    };
    updateBilling(payload);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const onSuccessCheckout = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      const result = response.data;
      if (result?.url) {
        window.open(result.url, "_top");
      }
    }
  };

  const onErrorCheckout = (err) => {
    message.error(JSON.parse(err?.response?.data)?.message);
    setIsLoading(false);
  };

  const { mutate: checkout } = useInitiateCheckoutForBatch(
    onSuccessCheckout,
    onErrorCheckout
  );
  const checkoutPayment = async () => {
    const redirectby = searchParams.get("redirectby");
    const payload = {
      host: `${window.location.protocol}//${window.location.host}`,
      txnMetadata: redirectby ? JSON.stringify({ redirectby }) : JSON.stringify({ batchId: params.batchId }),
      mode: window.location.host === "localhost:3000" ? "test" : "live",
      batch: params.batchId,
    };
    checkout(payload);
  };

  const getBillingDetails = () => {
    return (
      <div className="billing_form">
        <form onSubmit={updateBillingInformation}>
          {formInputs.map((inputForm) => (
            <div key={inputForm.id} className={inputForm.className}>
              <input
                placeholder={inputForm.placeholder}
                name={inputForm.name}
                onChange={handleChange}
                required={inputForm.required}
                value={inputForm.value}
              />
            </div>
          ))}
          <div className="select_wrapper">
            <LocationSelector
              formData={formData}
              setFormData={setFormData}
              selectedCountries={formData?.country}
              selectedStates={formData?.stateOrProvince}
              selectedCitys={formData?.city}
            />
          </div>
          <div className="submit_btn_wrapper">
            <Link to={`/order-list`}>Cancel</Link>
            <Button
              text="Save & Pay"
              width="200px"
              height="50px"
              isDisabled={isLoading}
            />
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="my_plan_details">
      <div className="plan_section">
        <div className="plan_info">
          <div className="plan_title">
            <h2 className="plan_head">Total Amount To Pay</h2>
          </div>
          <div className="plan_pricing">
            <h3 className="pricing_title">
              {searchParams.get("currency")}
              {searchParams.get("rate")}
              {location?.state?.totalAmount} {location?.state?.currency}
            </h3>
          </div>
        </div>
        <div className="billing_info">
          <h2 className="billing_head">Billing Details</h2>
          {getBillingDetails()}
        </div>
      </div>
    </div>
  );
};

export default BillingDetails;
